import {Observable, Subject, BehaviorSubject, lastValueFrom} from "rxjs";

class RuntimeEventManagerService {
  private events = new Map<string, Subject<any>>();
  private serviceMap = new Map<string, any>();

  setService(name: any, val: any) {
    let service = this.serviceMap.get(name);
    if (!service) {
      this.serviceMap.set(name, val);
    }
  }

  getService(name: any) {
    return this.serviceMap.get(name);
  }

  // emit the event
  emit(name: string, payload?: any): void {
    const subject = this.events.get(name);
    if (subject) {
      subject.next(payload);
    }
  }

  // subscribe to the event
  on(name: string): Observable<any> {
    let subject = this.events.get(name);
    if (!subject) {
      subject = new Subject<any>();
      this.events.set(name, subject);
    }
    return subject.asObservable();
  }

  // unsubscribe to the event
  off(name?: string): void {
    if (!name) {
      this.events.clear();
      return;
    }
    const subject = this.events.get(name);
    if (subject) {
      subject.unsubscribe();
      this.events.delete(name);
    }
  }

  getPromise(name: string) {
    let subject = this.events.get(name);
    if (!subject) {
      subject = new BehaviorSubject<any>(null);
      this.events.set(name, subject);
    }
    return subject;
  }

  observeEvents(name: string): any {
    const subject = this.events.get(name);
    if (subject) {
      return lastValueFrom(subject);
    }
  }
}

export const runtimeEventManager = new RuntimeEventManagerService();
